import { Component, OnDestroy, inject } from '@angular/core';
import { MessageService } from './message.service';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
  standalone: false
})
export class MessageComponent implements OnDestroy {
  private messageService = inject(MessageService);

  ngOnDestroy() {
    this.messageService.message = '';
  }

  get message(): string {
    return this.messageService.message;
  }
}
